// Shared parsing for the freeform `carrier_tags` field returned by the v2
// carrier API. Tags are a comma-separated blob mixing state codes and lines of
// business (e.g. "CA,NY,Personal Auto,Flood"). LOB_KEYWORDS is the canonical
// set of lines of business; the parse classifies each tag against it so callers
// can filter carriers and build the LOB dropdown.

export const STATE_CODES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
  'VA','WA','WV','WI','WY','DC',
];

export const LOB_KEYWORDS = [
  'Personal Auto','Commercial Auto','Homeowners','Dwelling Fire',
  'Commercial Lines','Commercial Property','General Liability',
  'Professional Liability','Workers Comp','Umbrella','Flood',
  'Recreational Lines','Powersports','Agriculture','Trucking',
  'Health','Life','Cyber','E&O','D&O','EPLI','BOP','Excess Liability',
  'Manufactured Homes',
  // Lines of business present in HubSpot carrier_tags but previously missing from
  // this allowlist, so they never surfaced in the LOB dropdown (WIPE-505).
  'Special Events',"Builder's Risk",'Inland Marine','Short Term Rentals',
  'Vacant Property','Mobile Home','Boat','Wind Only',
  'Personal Articles Floater','Fine Art','Liquor Liability','Aviation',
  'Motor Truck Cargo','Garage Keepers','Premise Liability',
];

export interface ParsedCarrierTags {
  states: string[];
  linesOfBusiness: string[];
}

export function parseCarrierTags(tags: string | null): ParsedCarrierTags {
  if (!tags) return { states: [], linesOfBusiness: [] };
  const parts = tags.split(',').map(t => t.trim()).filter(Boolean);
  const states = parts.filter(t => STATE_CODES.includes(t));
  // Exact match against the canonical LOB set — a substring match would
  // classify carrier names like "Titan Flood" as the "Flood" line of business
  // and surface them in the LOB dropdown (WIPE-532).
  const linesOfBusiness = parts.filter(t => LOB_KEYWORDS.includes(t));
  return { states, linesOfBusiness };
}
